import { render, staticRenderFns } from "./eliminateDialog.vue?vue&type=template&id=712493b5&scoped=true&"
import script from "./eliminateDialog.vue?vue&type=script&lang=js&"
export * from "./eliminateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712493b5",
  null
  
)

export default component.exports